import React, { useState } from "react";
import styles from "./AdminEditStaffUser.module.css";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import CheckBox from '../../../../components/Checkbox/CheckBox';
import { Card, List } from 'antd';


import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
} from "../../../../components";

const AdminEditStaffUser = () => {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [branch, setBranch] = useState("");
  const [role, setRole] = useState({ value: "Select Role", id: 0 });
  const [department, setDepartment] = useState({
    value: "Select Department",
    id: 0,
  });
  const [email, setEmail] = useState("");
  const [designation, setDesignation] = useState("");
  const [password, setPassword] = useState("");


  const data = [
    {
      title: 'Mixing',
    },
    {
      title: 'Oven',
    },
    {
      title: 'Proof',
    },
    {
      title: 'Chill',
    },
    {
      title: 'Assembly',
    },
    {
      title: 'Packaging',
    },
    {
      title: 'Make Up',
    },
  ];

  const handleSubmit = () => {
    const formData = {
      fullName,
      branch,
      role: role.value,
      department: department.value,
      email,
      designation,
      password,
    };
    console.log("Submitted Data:", formData);
  };



  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };


  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <HeaderComponent
          heading={"Edit Staff User"}
          showBackIcon={true}

        />
      </div>
      <div className={styles.mainCont2}>

        <div className={styles.subCont}>

          <div className={styles.leftCont}>
            <InputField
              className={styles.inputNew}
              label={"First & Last Name"}
              placeholder={"Stacy Doe"}
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
            <InputField
              className={styles.inputNew}
              label={"Designation"}
              placeholder={"Head Mixer"}
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />

            <InputField
              className={styles.inputNew}
              label={"Password"}
              placeholder={"********"}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />


          </div>

          <div className={styles.rightCont}>
            <InputField
              className={styles.inputNew}
              label={"Email"}
              placeholder={"stacy.doe@example.com"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div style={{ marginTop: 20 }}>


              <Dropdown
                label={"Role"}
                value={role}
                style={{ color: "var(--black-color)" }}
                options={[
                  { value: "Supervisor", id: 1 },
                  { value: "Manager", id: 2 },
                  { value: "Staff", id: 3 },
                  { value: "Trainee", id: 4 },
                ]}
                onChange={(selected) => setRole(selected)}
              />
            </div>
            <div style={{ marginTop: 20 }}>

              <Dropdown
                label={"Primary Department"}
                value={department}
                style={{ color: "var(--black-color)" }}
                options={[
                  { value: "Mixing", id: 1 },
                  { value: "Oven", id: 2 },
                  { value: "Proof", id: 3 },
                  { value: "Chilli", id: 4 },
                  { value: "Assembly", id: 5 },
                  { value: "Packaging", id: 6 },
                  { value: "Make Up", id: 7 },

                ]}
                onChange={(selected) => setDepartment(selected)}
              />
            </div>


          </div>

        </div>
        <TextComponent text={"Station"} className={styles.stationText} />
        <div style={{ marginTop: 10 }}>

          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 4,
              xxl: 3,
            }}
            dataSource={data}
            renderItem={item => (
              <List.Item>
                <CheckBox onClick={onChange}>{item.title}</CheckBox>
              </List.Item>
            )}
          />
        </div>

        <div className={styles.btnContainer}>
          <SubmitButton
            title={"Save"}
            primary
            onClick={handleSubmit}
            btnContainerClass={styles.Login_btnContainer}
            textClass={styles.Login_Text}
            btnClass={styles.Login_btn}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminEditStaffUser;
